(ns manatee.accounts
  (:require [medley.core :as medley]))

(defn account-namer
  [account-ids]
  (fn [account-id]
    (or (some->> account-ids
                 (medley/find-first #(= (val %) account-id))
                 key
                 name)
        account-id)))
